import React from 'react';
import './OnPropertyExperience.css';
import Intro from './Intro';
import OptimizedImage from './OptimizedImage';
import keyDisplayImage from 'url:../../assets-optimized/redesign/solutions/on-property/key-display.png';
import keyDisplayImageavif from 'url:../../assets-optimized/redesign/solutions/on-property/key-display.avif';
import keyDisplayImagewebp from 'url:../../assets-optimized/redesign/solutions/on-property/key-display.webp';
import videoPlaylistsImage from 'url:../../assets-optimized/redesign/solutions/on-property/video-playlists.png';
import videoPlaylistsImageavif from 'url:../../assets-optimized/redesign/solutions/on-property/video-playlists.avif';
import videoPlaylistsImagewebp from 'url:../../assets-optimized/redesign/solutions/on-property/video-playlists.webp';
import uponArrivalImage from 'url:../../assets-optimized/redesign/solutions/on-property/upon-arrival.png';
import uponArrivalImageavif from 'url:../../assets-optimized/redesign/solutions/on-property/upon-arrival.avif';
import uponArrivalImagewebp from 'url:../../assets-optimized/redesign/solutions/on-property/upon-arrival.webp';

const ArrowUpRightIcon = () => (
  <svg viewBox='0 0 24 24' fill='none' aria-hidden='true'>
    <path
      d='M7 17L17 7M9 7H17V15'
      stroke='currentColor'
      strokeWidth='1.8'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const HeartIcon = () => (
  <svg viewBox='0 0 24 24' fill='none' aria-hidden='true'>
    <path
      d='M12 20.2L10.55 18.88C5.4 14.24 2 11.16 2 7.38C2 4.3 4.42 2 7.5 2C9.24 2 10.91 2.81 12 4.09C13.09 2.81 14.76 2 16.5 2C19.58 2 22 4.3 22 7.38C22 11.16 18.6 14.24 13.45 18.88L12 20.2Z'
      stroke='currentColor'
      strokeWidth='1.8'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const cards = [
  {
    title: 'Key Display',
    description: 'Your brand on guest TVs for up to 2 full minutes',
    image: { avif: keyDisplayImageavif, webp: keyDisplayImagewebp, fallback: keyDisplayImage },
    imageAlt: 'Hotel guests watching content on an in-room television',
    overlayTone: 'warm',
  },
  {
    title: 'Video Playlists',
    description: 'Seamlessly integrate into our Marriott Bonvoy loop',
    image: {
      avif: videoPlaylistsImageavif,
      webp: videoPlaylistsImagewebp,
      fallback: videoPlaylistsImage,
    },
    imageAlt: 'Traveler relaxing near a television screen featuring entertainment content',
    overlayTone: 'charcoal',
  },
  {
    title: 'Upon Arrival',
    description: 'Deliver your message in an uncluttered space',
    image: { avif: uponArrivalImageavif, webp: uponArrivalImagewebp, fallback: uponArrivalImage },
    imageAlt: 'Guest checking a phone in a hotel room after arrival',
    overlayTone: 'mist',
  },
];

const OnPropertyExperience = () => {
  return (
    <section className='op-experience-section'>
      <div className='op-experience-shell'>
        <div className='op-experience-intro'>
          <Intro>
            Travelers are already inspired during this phase. If your ad can amplify that feeling,
            {' '}you're not interrupting,
            <span className='audience-pill op-experience-pill'>
              <span className='op-experience-pill__icon'>
                <HeartIcon />
              </span>
              you're joining the experience
            </span>
          </Intro>
        </div>

        <div className='op-experience-grid'>
          {cards.map((card) => (
            <article key={card.title} className='op-card'>
              <OptimizedImage
                className='op-card__image'
                avif={card.image.avif}
                webp={card.image.webp}
                fallback={card.image.fallback}
                alt={card.imageAlt}
              />

              <div className={`op-card__overlay op-card__overlay--${card.overlayTone}`}>
                <h3 className='op-card__title'>{card.title}</h3>
                <p className='op-card__description'>{card.description}</p>
              </div>

              <span className='op-card__arrow'>
                <ArrowUpRightIcon />
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OnPropertyExperience;